import React, { useState } from "react";
import defaultCatalogImage from "../../assets/catalog-default.webp";

export { defaultCatalogImage };

// The default is presentation-only: never persist it over a missing or deferred photo.
export default function CatalogImage({ src, alt = "", onError, ...props }) {
  const [failedSource, setFailedSource] = useState(null);
  const source = typeof src === "string" ? src.trim() : "";
  const showDefault = !source || failedSource === source;

  return (
    <img
      loading="lazy"
      decoding="async"
      {...props}
      src={showDefault ? defaultCatalogImage : source}
      alt={alt}
      onError={(event) => {
        if (showDefault) return;
        setFailedSource(source);
        onError?.(event);
      }}
    />
  );
}
